/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_getCSRFResponse } from '../models/api_getCSRFResponse';
import type { api_getMeResponse } from '../models/api_getMeResponse';
import type { api_loginRequest } from '../models/api_loginRequest';
import type { api_loginResponse } from '../models/api_loginResponse';
import type { api_registerRequest } from '../models/api_registerRequest';
import type { api_registerResponse } from '../models/api_registerResponse';
import type { api_resetPasswordRequest } from '../models/api_resetPasswordRequest';
import type { api_sendPasswordResetEmailRequest } from '../models/api_sendPasswordResetEmailRequest';
import type { api_sendVerificationEmailRequest } from '../models/api_sendVerificationEmailRequest';
import type { api_validateOTPRequest } from '../models/api_validateOTPRequest';
import type { api_validateOTPResponse } from '../models/api_validateOTPResponse';
import type { api_verifyEmailResponse } from '../models/api_verifyEmailResponse';
import type { api_verifyOTPRequest } from '../models/api_verifyOTPRequest';
import type { api_verifyOTPResponse } from '../models/api_verifyOTPResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Auth {
    /**
     * Request a csrf token
     * @returns api_getCSRFResponse OK
     * @throws ApiError
     */
    public static getCsrf(): CancelablePromise<api_getCSRFResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/csrf',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Login with username and password
     * @param body Email Address and Password
     * @returns api_loginResponse OK
     * @throws ApiError
     */
    public static login(
        body: api_loginRequest,
    ): CancelablePromise<api_loginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/login',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Log out current session
     * @returns void
     * @throws ApiError
     */
    public static logout(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/auth/logout',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Details of authenticated user
     * @returns api_getMeResponse OK
     * @throws ApiError
     */
    public static getMe(): CancelablePromise<api_getMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/me',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Complete a user's registration after they verify their email
     * @param body User ID, Password, Register Token, Security Questions and Answers
     * @returns api_registerResponse OK
     * @throws ApiError
     */
    public static register(
        body: api_registerRequest,
    ): CancelablePromise<api_registerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/register',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Renew a user session
     * @returns void
     * @throws ApiError
     */
    public static renewSession(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/auth/renew-session',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Request a password reset email for a user
     * @param body Email address
     * @returns any OK
     * @throws ApiError
     */
    public static sendPasswordResetEmail(
        body: api_sendPasswordResetEmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/request-password-reset',
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Reset a user's password
     * @param body Token and password
     * @returns void
     * @throws ApiError
     */
    public static resetPassword(
        body: api_resetPasswordRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/reset-password',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Request a new verification email for a user
     * @param body User ID
     * @returns any OK
     * @throws ApiError
     */
    public static sendVerificationEmail(
        body: api_sendVerificationEmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/send-verification-email',
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Validate a user's OTP for MFA login
     * @param body User ID, MFAToken, Token
     * @returns api_validateOTPResponse OK
     * @throws ApiError
     */
    public static validateOtp(
        body: api_validateOTPRequest,
    ): CancelablePromise<api_validateOTPResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/validate-otp',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Verify that a user has a valid email address and register token
     * @param id User ID
     * @param registerToken Register token
     * @returns api_verifyEmailResponse OK
     * @throws ApiError
     */
    public static verifyEmail(
        id: number,
        registerToken: string,
    ): CancelablePromise<api_verifyEmailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/verify-email',
            query: {
                'id': id,
                'register_token': registerToken,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Verify a user's OTP for setting up a new authenticator
     * @param body User UUID, Token
     * @returns api_verifyOTPResponse OK
     * @throws ApiError
     */
    public static verifyOtp(
        body: api_verifyOTPRequest,
    ): CancelablePromise<api_verifyOTPResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/verify-otp',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
